// STEP 1 - Include Dependencies
// Include react
import React from "react";

// Include the react-fusioncharts component
import ReactFC from "react-fusioncharts";

// Include the fusioncharts library
import FusionCharts from "fusioncharts";

// Include the chart type
import Column2D from "fusioncharts/fusioncharts.charts";

// Include the theme as fusion
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
import LineGraph from "./LineGraph";
import { connect } from "react-redux";
import { AMC_DETAILS } from "../../variable";

// Adding the chart and theme as dependency to the core fusioncharts
ReactFC.fcRoot(FusionCharts, Column2D, FusionTheme);

function PieChart(props) {
  // STEP 2 - Chart Data
  //console.log("ABCD--", props.portfolioBox.portfolioView);
  let colors = [
    "#89C4F4",
    "#BBBBBB",
    "#337FC9",
    "#9AECF3",
    "#717171",
    "#36DAE9",
    "#333333",
    "#4492A8",
    "#66BCFF",
    "#7094C6",
    "#8ED8B7",
  ];
  let rows = [];
  props.portfolioBox.portfolioView.length > 0 &&
    Object.keys(props.portfolioBox.portfolioView).map((key, index) => {
      rows.push({
        key: key,
        label: props.portfolioBox.portfolioView[key]["fundType"],
        value:
          props.portfolioBox.portfolioView[key][
            AMC_DETAILS.INVESTMENT_TYPE == "openEnded"
              ? "totalContribution"
              : "totalCommitment"
          ],
        color: colors[index],
        link: `j-callLineChart-${props.portfolioBox.portfolioView[key]["fundType"]}`,
      });
    });

  let chartData = rows;
  //console.log("chartData in pie", chartData);

  //   {
  //     label: "Debt",
  //     value: props.portfolioBox.portfolioView["Debt Fund"],
  //     // value: "80",
  //     color: "#AD9042",
  //     link: "j-callLineChart-Debt",
  //   },
  //   {
  //     label: "Listed Equity",
  //     value: props.portfolioBox.portfolioView["Listed Equity"],
  //     // value: "10000055",
  //     color: "#F3DFAA",
  //     link: "j-callLineChart-Listed Equity",
  //   },
  //   {
  //     label: "Private Equity",
  //     value: props.portfolioBox.portfolioView["Private Equity"],
  //     // value: "80",Private Equity
  //     color: "#E6C774",
  //     link: "j-callLineChart-Private Equity",
  //   },
  //   {
  //     label: "Real Estate",
  //     value: props.portfolioBox.portfolioView["Real Estate"],
  //     // value: "80",
  //     color: "#CCB265",
  //     link: "j-callLineChart-Real Estate",
  //   },
  // ];

  // STEP 3 - Creating the JSON object to store the chart configurations
  const chartConfigs = {
    type: "pie2d", // The chart type
    width: "100%", // Width of the chart
    height: "170", // Height of the chart
    dataFormat: "json", // Data type
    dataSource: {
      // Chart Configuration
      chart: {
        numberSuffix: "K",
        showlabels: "0",
        showValues: "0",
        showToolTip: "1",
        legendPosition: "below",
        showLegend: "0",
        enableSlicing: "0",
        enableRotation: "0",
        // legendNumRows: "2",
        legendNumColumns: "1",
        legendItemFontSize: "12",
        // legendIconAlpha: "0",
        // labelBorderThickness: "10",
        //Set the theme for your chart
        theme: "fusion",
        chartLeftMargin: "0",
        chartTopMargin: "0",
        chartRightMargin: "0",
        chartBottomMargin: "0",
        plottooltext: "<b>$percentValue</b> <b>$label</b>",
        // showpercentvalues: "1",
      },
      // Chart Data
      data: chartData,
    },
    events: {
      dataplotClick: function (evt, args) {
        window.callLineChart = function (str) {
          props.setFundType(str);
          //console.log("str being set to fund type", str);
        };
      },
    },
  };

  return <ReactFC {...chartConfigs} />;
}

const mapStatetoProps = (state) => {
  return {
    fundType: state.mainReducer.fundType,
  };
};
const mapDispatchtoProps = (dispatch) => {
  return {
    setFundType: (val) => {
      dispatch({ type: "CHANGE-FUND-TYPE", fundType: val });
    },
  };
};

export default connect(mapStatetoProps, mapDispatchtoProps)(PieChart);
